import { useEffect } from 'react';
import { useNotificationCount } from './queries/useNotifications';

/**
 * PWA 앱 아이콘 배지 — 홈 화면 아이콘의 미읽음 개수 (PC + Mobile 공유, 2026-09-23).
 *
 * 왜 공유 훅인가:
 *   기존에는 `Layout.jsx`(데스크톱 셸)에만 `setAppBadge` 가 있었다.
 *   manifest 의 start_url 이 `/mobile/home` 이라 홈 화면에 설치한 PWA 는
 *   `Layout` 을 절대 렌더하지 않는다 → 배지가 한 번도 표시된 적이 없었다.
 *   모바일 셸(MobileAuthGuard)에도 같은 훅을 붙여 양쪽에서 동작하게 한다.
 *
 * 기준값은 **미읽음 알림 수**. 승인 대기 건수만 세면 일반 알림이 와도 배지가 안 뜬다.
 *
 * @param {number} [extraCount] - 추가로 합산할 건수 (예: 승인 대기)
 */
export default function useAppBadge(extraCount = 0) {
  const { data: unread } = useNotificationCount();

  useEffect(() => {
    if (typeof navigator === 'undefined') return;

    const count = (Number(unread) || 0) + (Number(extraCount) || 0);

    // 브라우저/OS 미지원 시 조용히 무시 (iOS Safari 등)
    if (count > 0) {
      navigator.setAppBadge?.(count).catch(() => {});
    } else {
      navigator.clearAppBadge?.().catch(() => {});
    }
  }, [unread, extraCount]);
}
